import React, { memo } from 'react';
import { CardModel } from '../../../../lib/shared-models/card.model';
import { CardProps } from '../../../../types/types';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import Card from './components/card';

const StoriesCard = (props: CardProps & { onClick; cardHeadingTag; isGradientDisabled; textColor }): JSX.Element => {
  const isEE = props.sitecoreContext?.pageEditing;
  const model = new CardModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  const disable = model.link?.value?.href ? '' : 'stories-card--disable';
  return (
    <>
      {isEE ? (
        <div className="stories-card">
          <Card
            isEE={isEE}
            image={model.image}
            mobileImage={model.mobileImage}
            title={model.title}
            link={model.link}
            isGradientDisabled={props?.isGradientDisabled}
            textColor={props?.textColor}
            cardHeadingTag={props?.cardHeadingTag}
          />
        </div>
      ) : (
        <RoutableSitecoreLink
          onClick={props.onClick}
          target={targetLinkdsk(model?.link, isDesktop)}
          className={`stories-card ${disable}`}
          field={model.link}
        >
          <Card
            isEE={isEE}
            image={model.image}
            mobileImage={model.mobileImage}
            title={model.title}
            link={model.link}
            isGradientDisabled={props?.isGradientDisabled}
            textColor={props?.textColor}
            cardHeadingTag={props?.cardHeadingTag}
          />
        </RoutableSitecoreLink>
      )}
    </>
  );
};

export default memo(StoriesCard);
